export class GtmConsentModel {
  consentName: string;
  consentContent: string;
  consentAdditionalContent: string;
  consentObligatory: number;
}
